import { focusManager } from '@tanstack/react-query';

type FocusListenerSetup = Parameters<typeof focusManager.setEventListener>[0];

// TanStack's default hears only visibilitychange, which never fires when a reviewer moves between two visible browser windows.
export const listenForFocus: FocusListenerSetup = (handleFocus) => {
    const onFocus = () => handleFocus();
    const onVisibilityChange = () => {
        if (document.visibilityState === 'visible') handleFocus();
    };
    window.addEventListener('focus', onFocus);
    document.addEventListener('visibilitychange', onVisibilityChange);
    return () => {
        window.removeEventListener('focus', onFocus);
        document.removeEventListener('visibilitychange', onVisibilityChange);
    };
};
